export default __webpack_public_path__ + "static/media/fund.0185e5f3.svg";